// Navbar.js
import React, { useState } from 'react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { Transition } from '@headlessui/react';
import Logo from "../assets/Logo";
import {Link} from "react-router-dom"; 
import WhatsAppSupportLink from "./WhatsAppSupportLink"; 

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <nav className="bg-white shadow-md  w-full z-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Left Section: Hamburger Menu and Logo */}
          <div className="flex items-center">
            {/* Hamburger Menu (Visible on Mobile) */}
            <div className="mr-2 flex md:hidden">
              <button
                onClick={toggleMenu}
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition duration-300"
                aria-controls="mobile-menu"
                aria-expanded={isOpen}
              >
                <span className="sr-only">Open main menu</span>
                {isOpen ? (
                  <XIcon className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>

            {/* Logo */}
            <div className="flex-shrink-0 flex items-center gap-3">
              <Logo size = "30px"/>         
				  <p className = "md:text-xl text-lg font-bold">Officialbillboard</p>
				</div>
          </div>

          {/* Right Section: Desktop Navigation Links */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <Link
              to="/"
              className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-300"
            >
              Home
            </Link>
            <Link
              to="/signup"
              className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-300"
            >
              Signup
            </Link>
            <Link
              to="/login"
              className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-300"
            >
              Login
            </Link>
            <Link
                to="/about"
                className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-300"
            >
              About 
            </Link>

				<WhatsAppSupportLink supportMessage = "contact us" />	
          </div>
        </div>
      </div>

      {/* Mobile Menu with Animation */}
      <Transition
        show={isOpen}
        enter="transition ease-out duration-300 transform"
        enterFrom="-translate-y-full opacity-0"
        enterTo="translate-y-0 opacity-100"
        leave="transition ease-in duration-200 transform"
        leaveFrom="translate-y-0 opacity-100"
        leaveTo="-translate-y-full opacity-0"
      >
        {(ref) => (
          <div className="md:hidden" id="mobile-menu">
            <div ref={ref} className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-md">
              <a
                href="#"
                className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium transition-colors duration-300"
              >
                Home
              </a>
              <Link
                to = "/signup"
                className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium transition-colors duration-300"
              >
				  signup
              </Link>
              <Link
                to="/login"
                className="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium transition-colors duration-300"
              >
                Login
              </Link>
              <Link
                to="/about"
                className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-300"
            >
              About 
            </Link>

				  <WhatsAppSupportLink supportMessage = "contact us"/> 
            </div>
          </div>
        )}
      </Transition>
    </nav>
  );
};
export default Header;

